// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"ced92219","169":"c8c92e86","181":"06eac0c6","294":"2d9d3200","607":"b7896d70"}[chunkId] + ".chunk.js";
};